var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-container bg-white dark-bg-custom"},[(_vm.isLoading)?_c('div',{staticClass:"loading-spinner"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"width":4,"color":"black"}})],1):_c('div',{staticStyle:{"width":"100%","height":"700px"},attrs:{"id":"map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }